import posthog from 'posthog-js';

const projectToken = import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN;
const apiHost = import.meta.env.VITE_PUBLIC_POSTHOG_HOST;

// Skipped in test mode so vitest and Playwright runs never hit the network;
// feature flags default to enabled there (see featureFlags.ts). Event capture
// under Firebase emulators is still suppressed in analytics.ts.
if (import.meta.env.MODE !== 'test') {
  if (!projectToken || !apiHost) {
    if (import.meta.env.DEV) {
      const missingVariable = projectToken
        ? 'VITE_PUBLIC_POSTHOG_HOST'
        : 'VITE_PUBLIC_POSTHOG_PROJECT_TOKEN';
      throw new Error(
        `${missingVariable} variable required by PostHog is missing or un-configured, this causes events to be silently missed. This error stops appearing once ${missingVariable} is configured`
      );
    }
  } else {
    posthog.init(projectToken, {
      api_host: apiHost,
      defaults: '2026-01-30',
      persistence: 'memory',
      // posthog-js re-fetches all feature flags on this interval while the tab
      // is visible (default: 5 min). Flags change rarely, so refresh hourly —
      // they still load once at init and on identify/reset regardless.
      remote_config_refresh_interval_ms: 60 * 60 * 1000,
      capture_pageview: 'history_change',
      capture_exceptions: {
        capture_unhandled_errors: true,
        capture_unhandled_rejections: true,
        capture_console_errors: false,
      },
      enable_recording_console_log: true,
    });
  }
}

export default posthog;
